import React, { useState } from "react";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FaqList = ({ question, answer, key }) => {
  const [showAnswer, setShowAnswer] = useState(false);
  return (
    <div
      key={key}
      onClick={() => setShowAnswer(!showAnswer)}
      className="!border-b !border-gray-800 mx-auto !py-3 !gap-x-2 first:!mt-0 mt-4 cursor-pointer"
    >
      <div>
        <div className="text-left w-full flex justify-between gap-x-3">
          <h4 className="text-[17px] lg:!text-[20px] !m-0 font-normal">
            {question}
          </h4>

          <div>
            {showAnswer ? (
              <FontAwesomeIcon icon={faChevronUp} />
            ) : (
              <FontAwesomeIcon icon={faChevronDown} />
            )}
          </div>
        </div>

        <div
          className={`transition-all duration-300 ease-in-out ${
            showAnswer ? "max-h-screen opacity-100 mt-3" : "max-h-0 opacity-0"
          } overflow-hidden`}
        >
          <div
            className={`transition-opacity duration-300 ease-in-out text-[14px] text-justify lg:text-[16px] text-gray-400 ${
              showAnswer ? "opacity-100" : "opacity-0"
            }`}
          >
            {answer}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqList;
